// 产品数据文件
const productData = {
    // 产品分类
    categories: [
        {
            id: 'video',
            name: '视讯产品线',
            enName: 'VIDEO PRODUCTS',
            icon: 'video-icon'
        },
        {
            id: 'live',
            name: '点直播产品线',
            enName: 'LIVE BROADCASTING PRODUCTS',
            icon: 'live-icon'
        },
        {
            id: 'education',
            name: '教育产品线',
            enName: 'EDUCATION PRODUCTS',
            icon: 'education-icon'
        }
    ],

    // 各分类下的产品
    products: {
        // 视讯产品线
        video: [
            {
                id: 'cloud-meeting',
                name: '云会议',
                description: 'LX云会议系统是多方视频通信解决方案，支持多人实时通话、屏幕共享、白板协作、会议录制等功能，能保持低延迟并大幅降低服务器资源消耗，自适应不同带宽、设备性能与网络状况，有效减少卡顿与延迟，为多场景提供高并发、低成本、易扩展的业务支撑。',
                image: 'cloud_meeting.png',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 60, // 自定义属性: 图片区域占百分比
                    }
                },
                link: '/products/video/cloud-meeting',
                markdown: 'cloud-meeting',
                features: [
                    { icon: 'adaptive', text: '自适应' },
                    { icon: 'lowlatency', text: '低延迟' },
                    { icon: 'concurrent', text: '高并发' },
                    { icon: 'multiscene', text: '多场景' }
                ],
            },
            {
                id: 'mcu',
                name: 'MCU服务',
                description: 'LX MCU是一款突破传统MCU架构的软件形态融合通信平台，实现会议资源集中管理与弹性扩展，支持会议室终端、PC、移动设备及浏览器等多种接入方式。平台可灵活部署于Bare Metal、Docker容器、虚拟机及公有云，满足多行业、多规模业务场景下的高效协作需求。',
                image: 'server.svg',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 40, // 自定义属性: 图片区域占百分比
                        padding: "0% 15% 0 4%", // 图片最大高度
                        top: "-40px", // 图片顶部偏移量
                    },
                    mobile: {
                        width: '25vh',
                        alignSelf: 'center',
                    }
                },
                link: '/products/video/mcu',
                markdown: 'mcu',
                features: [
                    { icon: 'soft', text: '软件架构' },
                    { icon: 'mix', text: '融合通信' },
                    { icon: 'scale', text: '弹性扩容' },
                    { icon: 'cross-platform', text: '跨平台' },
                    { icon: 'flexible', text: '灵活部署' },
                ]
            },
            {
                id: 'lx680',
                name: '会议终端',
                description: 'LX680/700是一款一体式/分体式的视讯会议终端，支持多种音视频编解码格式。内置噪声抑制和回声消除算法，为用于提供卓越的会议体验，是视频会议、指挥调度、在线教育、远程医疗等专业应用的理想选择。',
                image: 'lxxxx450.jpg',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 30, // 自定义属性: 图片区域占百分比
                        // padding: "0% 0% 0 10%", // 图片最大高度
                        maxWidth: "680px", // 图片最大宽度
                        maxHeight: "347px", // 图片最大高度
                    },
                },
                link: '/products/video/lx680',
                markdown: 'lx680',
                features: [
                    { icon: 'android', text: 'AndroidOS' },
                    { icon: 'voip', text: '协议兼容' },
                    { icon: '3a', text: '内置3A' },
                    { icon: 'screens', text: '双屏异显' },
                    { icon: 'hd', text: '高清画质' },
                ]
            },
        ],

        // 点直播产品线
        live: [
            {
                id: 'MBSStudio',
                name: '导播客户端',
                description: 'MBSStudio是一款基于Android原生开发、专为平板设备打造的流媒体导播客户端，支持多协议、多设备媒体接入，融合OBS核心能力与广电导播流程，提供画面预监、图层混合、实时推流、本地录制、素材叠加等功能，为直播制作和远程会议提供专业级移动导播解决方案。',
                image: 'mbs_studio.jpg',
                link: '/products/live/mbsStudio',
                markdown: 'mbsStudio',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 40, // 自定义属性: 图片区域占百分比
                    },
                },
                features: [
                    { icon: 'director', text: '专业导播' },
                    { icon: 'realtime', text: '实时预览' },
                    { icon: 'protocols', text: '全协议' },
                    { icon: 'layers', text: '分层混合' }
                ]
            },
            {
                id: 'mbs',
                name: '点直播服务',
                description: '点直播服务是一套集直播推流、点播播放、录制转码、内容管理和分发于一体的后端服务平台，支持多终端接入、超大规模并发分发、丰富格式兼容和灵活的API调用，广泛适用于会议直播、教学录播、政企点播等场景。',
                image: 'server.svg',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 40, // 自定义属性: 图片区域占百分比
                        padding: "0% 15% 0 4%", // 图片最大高度
                        top: "-40px", // 图片顶部偏移量
                    },
                    mobile: {
                        width: '25vh',
                        alignSelf: 'center',
                    }
                },
                link: '/products/live/mbs',
                markdown: 'mbs',
                features: [
                    { icon: 'protocols', text: '协议丰富' },
                    { icon: 'concurrent', text: '高并发' },
                    { icon: 'security', text: '安全加密' },
                    { icon: 'realtime', text: '实时录制' },
                    { icon: 'api', text: 'API支持' }
                ]
            }
        ],

        // 教育产品线
        education: [
            {
                id: 'aio',
                name: '互动录播一体机',
                description: 'AIO700集录播与互动教学应用于一体，支持多路音视频信号接入，提供多种画面合成方式，支持手动和自动导播模式，支持高清录制、直播以及点播，适用于多种教育场景。',
                image: 'aio700.png',
                imageStyle: {
                    desktop: {
                        imageRatioWithDesc: 40, // 自定义属性: 图片区域占百分比
                    },
                },
                link: '/products/education/aio',
                markdown: 'aio',
                features: [
                    { icon: 'switch', text: '双模式' },
                    { icon: 'multiscene', text: '多场景' },
                    { icon: 'director', text: '智能导播' },
                    { icon: 'protocols', text: '多协议' },
                    { icon: 'ai', text: 'AI接入' }
                ]
            },
        ]
    },

    // 首页展示的精选产品
    featuredProducts: [
        {
            series: 'video',
            id: 'cloud-meeting',
            name: '云会议',
            desc: 'LX云会议系统是多方视频通信解决方案，支持多人实时通话、屏幕共享、白板协作、会议录制等功能，能保持低延迟并大幅降低服务器资源消耗，自适应不同带宽、设备性能与网络状况，有效减少卡顿与延迟，为多场景提供高并发、低成本、易扩展的业务支撑。',
            image: 'cloud_meeting.png',
            link: '/products/video/cloud-meeting',
        },
        {
            series: 'live',
            id: 'MBSStudio',
            name: '导播客户端',
            desc: 'MBSStudio是一款基于Android原生开发、专为平板设备打造的流媒体导播客户端，支持多协议、多设备媒体接入，融合OBS核心能力与广电导播流程，提供画面预监、图层混合、实时推流、本地录制、素材叠加等功能，为直播制作和远程会议提供专业级移动导播解决方案。',
            image: 'mbs_studio.jpg',
            link: '/products/live/mbsStudio',
        },
        {
            series: 'video',
            id: 'lx680',
            name: '会议终端',
            desc: 'LX680/700是一款一体式/分体式的视讯会议终端，支持多种音视频编解码格式。内置噪声抑制和回声消除算法，为用于提供卓越的会议体验，是视频会议、指挥调度、在线教育、远程医疗等专业应用的理想选择。',
            image: 'lx680.jpg',
            imageStyle: {
                mobile: {
                    width: '100%',
                    alignSelf: 'center',
                },
            },
            link: '/products/video/lx680',
        },
        // {
        //     series: 'education',
        //     id: 'aio',
        //     name: '互动录播一体机',
        //     desc: 'AIO700集录播与互动教学应用于一体，支持多路音视频信号接入，提供多种画面合成方式，支持手动和自动导播模式，支持高清录制、直播以及点播，适用于多种教育场景。',
        //     image: 'aio700.png',
        //     link: '/products/education/aio',
        //     // imageWidth: '50%',
        //     // imageTop: '6%',
        //     // imageLeft: '27%',
        // },
    ]
};

export default productData;

// 获取产品样式
export const getProductImageStyle = (product, deviceType) => {
if (!product) return {};

const imageStyle = product.imageStyle?.[deviceType];
if (!imageStyle) return {};

if (imageStyle.imageRatioWithDesc) {
    return {flex: `1 1 ${imageStyle.imageRatioWithDesc}%`, ...imageStyle}
} else {
    return {...imageStyle};
}
};

export const getProductDescriptionStyle = (product, deviceType) => {
if (!product) return {};

const imageStyle = product.imageStyle?.[deviceType];
if (!imageStyle) return {};

if (imageStyle.imageRatioWithDesc) {
    return {flex: `1 1 ${100 - imageStyle.imageRatioWithDesc}%`}
} else {
    return {};
}
};